import styled from 'styled-components';
import { pxToRem } from '@leaftrade/leaftrade-component-library';

export const SpinnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: auto;
  & svg {
    width: ${pxToRem(250)};
    height: ${pxToRem(250)};
  }
`;
